import { createStore } from 'redux';
import { combineReducers } from 'redux';

const todo  = (state = {}, action) => {
	switch (action.type) {
		case 'ADD_TODO':
		return {
			  id: action.id,
			  text: action.text,
			  completed: false
		  };

		case 'TOGGLE_TODO':
		return (state.id !== action.id) ? state : {...state, completed: !state.completed };


		default: 
			return state;
	}
};

export const todos = (state = [], action) => {
	switch (action.type) {
		case 'ADD_TODO':
		return [ ...state, todo( {}, action ) ];

		case 'TOGGLE_TODO':
		return state.map((t) => todo(t, action));


		default: 
			return state;
	}
};


////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Composition object
////////////////////////////////////////////////////////////////////////////////////////////////////////////

const visibilityFilter = ( state = 'SHOW_ALL', action ) => {
	switch (action.type) {
		case 'SET_VISIBILITY_FILTER': return action.filter;

		default: return state;
	}
};

// combine reducers
const todoApp = combineReducers({
	todos,
	visibilityFilter
});

const store = createStore(todoApp);

export default store;



// WEBPACK FOOTER //
// ./src/pages/basics/todo-refactor/todo.reducer.js